var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.2C10.7233 4.2 11.417 4.495 11.9285 5.0201C12.4399 5.5452 12.7273 6.25739 12.7273 7C12.7273 7.74261 12.4399 8.4548 11.9285 8.9799C11.417 9.505 10.7233 9.8 10 9.8C9.27668 9.8 8.58299 9.505 8.07153 8.9799C7.56006 8.4548 7.27273 7.74261 7.27273 7C7.27273 6.25739 7.56006 5.5452 8.07153 5.0201C8.58299 4.495 9.27668 4.2 10 4.2ZM10 0C14.5455 0 18.4273 2.90267 20 7C18.4273 11.0973 14.5455 14 10 14C5.45455 14 1.57273 11.0973 0 7C1.57273 2.90267 5.45455 0 10 0ZM1.98182 7C3.48182 10.136 6.58182 12.1333 10 12.1333C13.4182 12.1333 16.5182 10.136 18.0182 7C16.5182 3.864 13.4182 1.86667 10 1.86667C6.58182 1.86667 3.48182 3.864 1.98182 7Z",
    fill: "#005FEA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eyeIcon.8348e8d1593938c02c256abd0e91c6d9.svg";